module.exports = {
  App: process.env.APP,
  apiHost: process.env.API_HOST,
  basePath: process.env.BASE_PATH,
  baseUrl: process.env.BASE_URL,
  requestTimeout: process.env.REQUEST_TIMEOUT,
  i18nPath: process.env.I18N_PATH,
}
